<script setup>
import { ref, computed } from 'vue';
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
const storedRoles = localStorage.getItem('rol');
const roles = ref(storedRoles ? JSON.parse(storedRoles) : []);

import SidenavItem from "./SidenavItem.vue";

const store = useStore();

const hasPersonalRole = computed(() => {
  return roles.value && roles.value.some(role => role.name === 'PERSONAL');
});
const hasProfesionalRole = computed(() => {
  return roles.value && roles.value.some(role => role.name === 'PROFESIONAL');
});

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};
const router = useRouter()
const logOut = () => {
  store.dispatch('auth/logout');
  router.push('/');
};
</script>
<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          to="/mis-solicitudes"
          :class="getRoute() === 'mis-solicitudes' ? 'active' : ''"
          navText='Mis Solicitudes'
        >
          <template v-slot:icon>
            <i
              class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="hasPersonalRole || hasProfesionalRole">
        <sidenav-item
          to="/solicitudes"
          :class="getRoute() === 'solicitudes' ? 'active' : ''"
          navText='Solicitudes'
        >
          <template v-slot:icon>
            <i
              class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="hasProfesionalRole">
        <sidenav-item
          to="/estadisticas"
          :class="getRoute() === 'estadisticas' ? 'active' : ''"
          navText='Estadísticas y reportes'
        >
          <template v-slot:icon>
            <i class="ni ni-chart-bar-32 text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="hasPersonalRole">
        <sidenav-item
          to="/estadisticas-personal"
          :class="getRoute() === 'estadisticas-personal' ? 'active' : ''"
          navText='Estadísticas y reportes'
        >
          <template v-slot:icon>
            <i class="ni ni-chart-bar-32 text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2"
        >
          CONFIGURACION
        </h6>
      </li>

      <li class="nav-item" v-if="hasPersonalRole">
        <sidenav-item
          to="/acceso"
          :class="getRoute() === 'acceso' ? 'active' : ''"
          navText='Acceso Aplicación Web'
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/perfil"
          :class="getRoute() === 'perfil' ? 'active' : ''"
          navText='Perfil'
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <a href="javascript:;" class="router-link-exact-active nav-link" @click="logOut">Cerrar Sesion</a>
      </li>
    </ul>
  </div>
</template>
